import React from 'react';
import { DialogRequestTypeHeader as RequestTypeHeader, ShiftCardInfo } from '../../../App/components/core';
import { isRangeOverlapping } from '../../../../common-client2/src/services/dateTime';
import { RequestTypes } from '../../../Enums';
import { isPartialOfShift } from '../Utils/PartialShiftHelper';
import { removeBrowserTimezoneConversion } from '../../../../common-client2/src/services/ukgDateTime';

/**
 * @template T
 * @param {T & {
 *  request?: Request;
 *  person?: *;
 * }} param0
 */
const ConfirmDialogContent = ({ request = {}, person }) => {
    if (!Object.keys(request).length) {
        return <></>;
    }

    const {
        type, shifts, proposals, proposalIdSelected, raw, partialDates
    } = request;

    switch (type) {
        case RequestTypes.toCover: {
            const shiftsDetails = raw?.isPartial ? [raw?.partialShift] : shifts;
            return (<>
                <RequestTypeHeader requestTypeName={'toCover'} />
                {
                    shiftsDetails.map(shift => <ShiftCardInfo
                        shiftDetails={shift}
                        actionType={type}
                        isPartial={raw?.isPartial}
                    />)
                }
            </>);
        }
        case RequestTypes.shiftSwap: {
            const shiftsDetails = raw?.isPartial ? [raw?.partialShift] : shifts;
            const proposalSelected = proposals.find((x) => x.proposalId === proposalIdSelected);
            const proposalShiftDetails = proposalSelected?.isPartial ? [proposalSelected?.partialShift] : proposalSelected?.shifts;
            let i = 0;
            return (<>
                <RequestTypeHeader requestTypeName={'shiftSwap'} />
                {
                    shiftsDetails.map(shift => <ShiftCardInfo
                        shiftDetails={shift}
                        actionType={type}
                        isPartial={raw?.isPartial}
                    />)
                }

                {!!proposalSelected &&
                    proposalShiftDetails.map(shift => <ShiftCardInfo
                        shiftDetails={shift}
                        employeeName={i++ === 0 ? proposalSelected.proposalEmployeeName : undefined}
                        actionType={type}
                        isPartial={raw?.isPartial}
                    />)
                }
            </>);
        }
        case RequestTypes.openShift: {
            let shiftsDetails = shifts;
            let isPartial = false;

            const isPartialAndDifferentFromBase = isPartialOfShift(partialDates, shifts[0])

            if (isPartialAndDifferentFromBase) {
                const segments = shiftsDetails[0]?.segments?.filter(x =>
                    isRangeOverlapping(x.startDateTime, x.endDateTime, partialDates.startDate, partialDates.endDate, true));
                
                shiftsDetails = [{
                    startDateTime: removeBrowserTimezoneConversion(partialDates.startDate),
                    endDateTime: removeBrowserTimezoneConversion(partialDates.endDate),
                    segments: segments,
                }];
                isPartial = true;
            }

            return (
                <>
                    <RequestTypeHeader requestTypeName={'openShift'} />

                    {
                        shiftsDetails.map(shift => <ShiftCardInfo
                            shiftDetails={shift}
                            actionType={type}
                            isPartial={isPartial}
                        />)
                    }
                </>
            );
        };
        case RequestTypes.voluntaryTimeOff: {
            const isPartial = isPartialOfShift(partialDates, {startDateTime: raw.timeOffStartDate, endDateTime: raw.timeOffEndDate})

            const startDateTime = isPartial
                ? removeBrowserTimezoneConversion(partialDates.startDate)
                : raw.timeOffStartDate;
            const endDateTime = isPartial
                ? removeBrowserTimezoneConversion(partialDates.endDate)
                : raw.timeOffEndDate;

            return (<>
                <RequestTypeHeader requestTypeName={'voluntaryTimeOff'} />
                <ShiftCardInfo
                    shiftDetails={{ startDateTime, endDateTime }}
                    actionType={type}
                    showDatesOnly
                    isPartial={isPartial}
                />
            </>);
        }
        default:
            return <></>;
    }
};

export default ConfirmDialogContent;